import { Button, styled } from '@mui/material';

export const ButtonDownloadStyled = styled(Button)(({ theme }) => ({
  width: '45px',
  minWidth: '45px',
  height: '32px',
  backgroundColor: theme.palette.colors.secondaryBackground,
  color: theme.palette.colors.mainFocused,
  border: `1px solid ${theme.palette.colors.borderLine}`,
  padding: 0,
  marginLeft: '24px',
  '&:hover': {
    borderColor: theme.palette.colors.mainFocused,
    backgroundColor: theme.palette.colors.secondaryBackground,
  },
  '&:disabled': {
    border: 0,
    backgroundColor: theme.palette.colors.off,
  },
}));
